<template>
  <div id="app">
    <el-container
      class="app-wrap"
    >
      <el-aside
        width="180px"
        class="app-aside"
      >
        <Nav v-if="hasGroup"></Nav>
      </el-aside>
      <el-container>
        <el-header
          height="70px"
          class="app-header"
        >
          <top-header @setGlobleGroup="setGroup"></top-header>
        </el-header>
        <el-main
          class="app-main"
        >
          <div class="app-router-wrap">
            <router-view v-if="hasGroup"/>
          </div>
          <footer class="app-footer">&#9400; 北京小桔科技有限公司 京公网安备11010802015048号 京ICP备12043664号-5</footer>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import TopHeader from './components/TopHeader'
import Nav from './components/Nav'
import './styles/customStyle.styl'
import './styles/common.styl'
import { Loading } from 'element-ui'
export default {
  data () {
    return {
      hasGroup: false
      // fullscreenLoading: true
    }
  },
  components: {
    TopHeader,
    Nav
  },
  mounted () {
    Loading.service({ fullscreen: true, background: 'rgba(0, 0, 0, 0.8)' })
  },
  methods: {
    setGroup (flag) {
      this.hasGroup = flag
      let loadingInstance = Loading.service({ fullscreen: true, background: 'rgba(0, 0, 0, 0.8)' })
      loadingInstance.close()
    }
  }
}
</script>

<style>
  html,body{
    font-family: PingFang SC, STHeitiSC-Light, Helvetica-Light, arial, sans-serif;
  }
  html,body,#app,.app-wrap{
    height: 100%
  }
  body,h2,h4,p,ul{
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  ul{
    list-style: none
  }
  .el-header.app-header{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.06);
    padding: 0;
  }
  .el-main.app-main{
    padding: 10px 10px 0 10px;
    height: 100%;
    background: #eee;
    min-width: 1060px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .app-router-wrap{
    width: 100%;
    border-radius: 2px;
    background: #fff;
    -webkit-box-flex:1;
    -ms-flex:1;
    flex:1;
  }

  .el-aside {
    background-color: #11111A;
    color: #fff;
    text-align: center;
  }
  .el-aside.app-aside{
    overflow: hidden;
  }
  .app-footer{
    background: #eee;
    line-height: 40px;
    padding-left: 10px;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
  }
  /* .loadingwrap{
    position: absolute;
    top: 66px;
    bottom: 0;
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .el-icon-loading{
    margin-top: 20%;
    margin-left: -13%
  }
  .loadingwrap .el-icon-loading:before {
      font-size: 60px;
      color: #acafb7;
    } */
</style>
